// Admin-editable texts: D1 stores only overrides keyed by dotted path ("hero.sub").
// translations.js stays the fallback for every key that has no override.
export const DB_LOCALES = [
  { code: "it", db: "it", label: "IT" },
  { code: "en", db: "en", label: "EN" },
  { code: "es", db: "es", label: "ES" },
  { code: "pt", db: "pt-BR", label: "PT-BR" },
];
export const dbLocale = (lang) => (lang === "pt" ? "pt-BR" : lang);

// Lists in translations.js (e.g. marquee) are edited as one text, items separated by " | ".
export const SEP = " | ";

export const flatten = (obj, prefix = "", out = {}) => {
  Object.entries(obj).forEach(([k, v]) => {
    const key = prefix ? `${prefix}.${k}` : k;
    if (v && typeof v === "object" && !Array.isArray(v)) flatten(v, key, out);
    else if (typeof v === "string" || Array.isArray(v)) out[key] = v;
  });
  return out;
};

export const toText = (v) => (Array.isArray(v) ? v.join(SEP) : v);

const setPath = (obj, path, value) => {
  const parts = path.split(".");
  let cur = obj;
  for (const p of parts.slice(0, -1)) {
    if (!cur[p] || typeof cur[p] !== "object") return;
    cur = cur[p];
  }
  const last = parts[parts.length - 1];
  if (!(last in cur)) return;
  cur[last] = Array.isArray(cur[last]) ? value.split("|").map((s) => s.trim()).filter(Boolean) : value;
};

export const applyOverrides = (base, map) => {
  if (!map || typeof map !== "object" || Object.keys(map).length === 0) return base;
  const out = structuredClone(base);
  Object.entries(map).forEach(([k, v]) => {
    if (typeof v === "string") setPath(out, k, v);
  });
  return out;
};
